import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-530db932"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round md-48" }, "  ", -1))
const _hoisted_2 = ["textContent"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ico" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "info" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("span", { class: "size-stat title-medium" }, _toDisplayString(_ctx.formatSize(_ctx.totalSize)) + " из " + _toDisplayString(_ctx.formatSize(_ctx.maxSize)), 513), [
      [_vShow, _ctx.totalSize]
    ]),
    _withDirectives(_createElementVNode("div", {
      ref: "container",
      class: "files-container",
      onDrop: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args))),
      onDragover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args))),
      onDragleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)))
    }, [
      _withDirectives(_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addFile && _ctx.addFile(...args))),
        class: "skeleton"
      }, [
        _hoisted_1,
        _createElementVNode("span", {
          class: "body-medium",
          textContent: _toDisplayString(_ctx.skeletonText)
        }, null, 8, _hoisted_2)
      ], 512), [
        [_vShow, _ctx.files.length == 0]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, ({ name, size }, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: name,
          class: "file"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["mime-icon", 'ico-' + _ctx.getExtension(name)])
          }, _hoisted_4, 2),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: "title-small",
              textContent: _toDisplayString(name)
            }, null, 8, _hoisted_6),
            _createElementVNode("span", {
              class: "caption",
              textContent: _toDisplayString(_ctx.formatSize(size))
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("span", {
            onClick: ($event: any) => (_ctx.removeFile(i)),
            class: "material-icons-round"
          }, "", 8, _hoisted_8)
        ]))
      }), 128))
    ], 544), [
      [_vShow, _ctx.showFilesList]
    ]),
    _createVNode(_component_Field, {
      label: "Подпись",
      autocomplete: "off",
      modelValue: _ctx.caption,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.caption) = $event))
    }, null, 8, ["modelValue"]),
    _createElementVNode("input", {
      ref: "input-file",
      type: "file",
      multiple: "",
      hidden: "",
      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeFiles && _ctx.changeFiles(...args)))
    }, null, 544)
  ], 64))
}